import React from "react";

const Contact = () => {
  return (
    <div className="container">
      <h1>Contact Page</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum fugit
        adipisci voluptates quaerat autem, eveniet asperiores accusantium enim
        reiciendis magni repellat et nisi voluptatibus saepe maxime velit
        provident excepturi a. Nisi sequi ipsa possimus odit voluptas neque
        cumque provident. Illum, laudantium? Dignissimos unde perferendis
        voluptatum laboriosam deserunt architecto excepturi eveniet.
      </p>
    </div>
  );
};

export default Contact;
